<div class="notification-settings-item__container">
  <label class="notification-settings-item__switch" [for]="checkboxID">
    <input type="checkbox" [id]="checkboxID" [checked]="isChecked" (change)="onCheck($event)" />
    <div class="notification-settings-item__slider round"></div>
  </label>
</div>
